import { render, staticRenderFns } from "./special_news.vue?vue&type=template&id=738c05f6&scoped=true"
import script from "./special_news.vue?vue&type=script&lang=js"
export * from "./special_news.vue?vue&type=script&lang=js"
import style0 from "./special_news.vue?vue&type=style&index=0&id=738c05f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738c05f6",
  null
  
)

export default component.exports